/**
 * Whether the Enter key should confirm, or make a new line.
 *
 * On a desk keyboard Enter sends and Shift+Enter makes a line, the way every
 * chat application has worked for twenty years, and taking that away slows
 * down whoever is answering messages from a computer.
 *
 * A phone has no such pairing. Its on-screen keyboard offers a return key and
 * no Shift to hold with it, so the same rule makes a two-line reply
 * impossible and turns a stray thumb into a half-sentence sent to a customer.
 * There, Enter must make a line and the Send button must be the only way out.
 *
 * `pointer: coarse` is the question actually being asked — "is the primary
 * input a fingertip" — rather than screen width, which says nothing (a narrow
 * window on a desktop still has a real keyboard) or a touch-points count,
 * which is true of touchscreen laptops that also have a trackpad and a proper
 * Enter key.
 *
 * Read at the moment the key is pressed rather than cached, so a window
 * dragged to another screen, or a browser switched into device emulation,
 * answers correctly without anything having to re-render.
 */
export function enterConfirms(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true;
  return !window.matchMedia('(pointer: coarse)').matches;
}
